import React, { FC, ReactNode } from 'react';
import { IonList } from '@ionic/react';
import { StyledMobileMenu } from './AllieMobileMenu.styles';

export interface MobileMenuProps {
  children: ReactNode;
  menuId: string;
  contentId: string;
  className?: string;
  type?: 'overlay' | 'reveal' | 'push';
  side?: 'start' | 'end';
  disabled?: boolean;
  id?: string;
  headerComponent?: ReactNode;
  footerComponent?: ReactNode;
}

/**
 * AllieMobileMenu - Mobile menu component using Ionic
 * Configurable through props to avoid coupling with specific implementations
 */
export const AllieMobileMenu: FC<MobileMenuProps> = ({
  children,
  menuId,
  contentId,
  className,
  type = 'overlay',
  side = 'start',
  disabled = false,
  id,
  headerComponent,
  footerComponent,
}) => {
  return (
    <StyledMobileMenu
      contentId={contentId}
      menuId={menuId}
      id={id || menuId}
      className={className}
      type={type}
      side={side}
      disabled={disabled}
    >
      {headerComponent}
      <div className="scrollbar">
        <IonList className="list-menu" mode="md" style={{ paddingTop: '75px' }}>
          {children}
        </IonList>
      </div>
      {footerComponent}
    </StyledMobileMenu>
  );
};

AllieMobileMenu.displayName = 'AllieMobileMenu';
